import React from "react"
import { withPrefix } from "gatsby"

import CursorProvider from "context/cursor"

import Layout from "components/Layout"
import {
  Hero,
  Discover,
  Space,
  Limitless,
  Gallery,
  Residence,
  GalleryBottom,
  Baner,
  Location,
  About,
  Contact,
  CallToAction,
  Nav,
} from "page_components/opolska-landing"
import Popup from "components/Popup"

import { Apartments } from "page_components/investment"

const Investment = ({ location }) => {
  const investment = "Apartamenty Opolska O27"
  const investmentRaw = "apartamenty_opolska"

  return (
    <CursorProvider variant="opolska">
      <Layout
        location={location}
        rmGlobalPopup
        mainClass="opolska-landing"
        seo={{
          title: "Opolska O27, Katowice - new flats",
          description:
            "O27 in Katowice - modern flats by Trust Investment. Check the location, standard, layouts and available apartments.",
          image: withPrefix("/o27-og-image.jpg"),
          hreflang: [
            {
              lang: "pl",
              href: "https://trustinvestment.pl/mieszkania/katowice/o27/",
            },
            {
              lang: "en",
              href: "https://trustinvestment.pl/en/flats/katowice/o27/",
            },
            {
              lang: "uk",
              href: "https://trustinvestment.pl/ua/kvartyry/katowice/o27/",
            },
            {
              lang: "x-default",
              href: "https://trustinvestment.pl/mieszkania/katowice/o27/",
            },
          ],
        }}
      >
        <Nav />
        <Hero />
        <Discover />
        <Apartments
          investment={investment}
          investmentRaw={investmentRaw}
          header="Unique apartments"
        />
        <Space />
        <Gallery />
        <GalleryBottom />
        {/* <Catalog /> */}
        <Limitless />
        <Baner />
        <Location />
        <Residence />
        <About />
        <Contact />
        <CallToAction />
        <Popup type="o27" />
      </Layout>
    </CursorProvider>
  )
}

export default Investment
